import { render } from "./Star.vue?vue&type=template&id=20f1ed40"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Star.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20f1ed40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20f1ed40', __exports__)) {
    api.reload('20f1ed40', __exports__)
  }
  
  module.hot.accept("./Star.vue?vue&type=template&id=20f1ed40", () => {
    api.rerender('20f1ed40', render)
  })

}


export default __exports__